<template>
  <b-modal
    :id="modalId"
    title="Exam Details"
    size="lg"
    scrollable 
    centered
    hide-footer
  >
    <div v-if="exam" class="mx-3">
      <div class="d-flex justify-content-between">
        <div>
          <h5 class="text-primary">{{ exam.title }}</h5>
          <p class="text-muted">{{ exam.description }}</p>
        </div>
        <div>
          <div>
            <strong>Status:</strong>
            <span class="h3">
              <b-badge :variant="getExamStatusVariant(exam)" class="ml-2">{{exam.status}}</b-badge>
            </span>
          </div>
          <!-- <div>
            <strong>Attempts Remaining:</strong> {{ exam.attempts_remaining }}
          </div> -->
        </div>
      </div>
      <div class="mb-2 g-2">
        <!-- <b-row>
          <b-icon-calendar></b-icon-calendar>
          <strong class="mr-4">Schedule:</strong> {{ formatDateTime(exam.application_exam?.date) }}
        </b-row> -->
        <div class="d-flex align-items-center">
          <b-icon-alarm></b-icon-alarm>
          <strong class="mr-4 ml-1">Duration:</strong> {{ exam.duration ? exam.duration + 'minutes' : 'No duration'}}
        </div>
      </div>
      <div>
        <div class="h5 mt-4">
          Exam Questions:
        </div>
        <div v-for="(question, idx) in exam.questions" :key="idx" class="mb-3">
          <div class="h6">
            {{idx+1}}. {{question.text}}
          </div>
          <div v-if="question.question_type === 'multiple-choice'">
              <div v-for="(option, idx) in question.options" :key="idx" class="d-flex my-1 align-items-center">
                <b-form-radio
                  v-model="question.answer"
                  :value="option"
                  disabled
                  class="mr-2"
                  name="answer"
                ></b-form-radio>
               <div> {{ option }}</div> 
              </div>
          </div>
          <div v-else-if="question.question_type === 'identification'">
              Answer: <span class="font-weight-bold">{{ question.answer }}</span>
          </div>
          <div v-else>
              This question is {{ question.question_type }} type.
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>No exam details available.</p>
    </div>
    <b-button class="mt-5" block @click="$bvModal.hide(modalId)">Close</b-button>
  </b-modal>
</template>

<script>
export default {
  props: {
    exam: {
      type: Object,
      default: null,
    },
  },
  computed: {
    formattedSchedule() {
      if (this.exam.schedule_start && this.exam.schedule_end) {
        return `${this.exam.schedule_start} - ${this.exam.schedule_end}`;
      }
      return "Not Scheduled";
    },
    modalId() {
      return this.exam?._id ? `exam-details-modal-${this.exam._id}` : 'exam-details-modal-default';
    },
  },
  methods: {
    show(){
      this.$nextTick(() => { // make sure exam is already reactive before showing
        this.$bvModal.show(this.modalId);
      });
    },
    getExamStatusVariant(exam) {
      return exam.status === "Open"
        ? "success"
        : exam.status === "Closed"
        ? "danger"
        : "secondary";
    },
    formatDateTime(dateTime) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date(dateTime).toLocaleString(undefined, options);
    },
    formattedTime(time) {
     if(time){
      const [hours, minutes, seconds] = time.split(":");
      const date = new Date();
      date.setHours(hours, minutes, seconds);
      return date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      });
     }else{
      return
     }
    },
  },
  mounted(){
    
  }
};
</script>
